export const ACTIONS = {
  MODAL_OPEN: 'MODAL_OPEN',
  MODAL_CLOSE: 'MODAL_CLOSE',
};

type CloseIconAttributes = {
  placeCloseIcon?: boolean;
  closeIconSize?: number;
  top?: number;
  right?: number;
};

type BackdropFilterData = {
  blurValue?: string;
  bgColor?: string;
};

type ModalStyle = {
  [key: string]: string;
};

export type ModalOptions = {
  size?: string;
  width?: string;
  height?: string;
  radius?: string;
  overflow?: string;
  blocking?: boolean;
  transparent?: boolean;
  outSideCloseButton?: boolean;
  backdropFilter?: boolean;
  hideScrollBar?: boolean;
  closeIconAttributes?: CloseIconAttributes;
  backdropFilterData?: BackdropFilterData;
  modalZIndex?: number;
  onClose?: () => void;
  style?: ModalStyle;
};

type Payload = {
  name: string;
  options?: ModalOptions;
  props?: unknown;
};

export type OpenModal = (
  name: string,
  options?: ModalOptions,
  props?: unknown,
) => {
  type: typeof ACTIONS.MODAL_OPEN;
  payload: Payload;
};

export const openModal: OpenModal = (name, options = {}, props) => ({
  type: ACTIONS.MODAL_OPEN,
  payload: { name, options, props },
});

export const closeModal = () => ({ type: ACTIONS.MODAL_CLOSE });
